var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _c("div", { staticClass: "top_header" }, [
      _c("div", { staticClass: "top_header_con" }, [
        _c("img", {
          staticClass: "top_logo",
          attrs: { src: require("@/assets/images/newLogo.png") }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "top_line",
          attrs: { src: require("@/assets/images/line.png") }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "top_nav" }, [
          _c(
            "div",
            {
              staticClass: "navfont2",
              class: [_vm.activeMenu === "/" ? "active" : ""],
              on: {
                click: function($event) {
                  return _vm.goTo("/")
                }
              }
            },
            [_c("a", [_vm._v("首页")])]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "navfont2",
              class: [_vm.activeMenu === "/newIndex" ? "active" : ""],
              on: {
                click: function($event) {
                  return _vm.goTo("/newIndex")
                }
              }
            },
            [_c("a", [_vm._v("最新消息")])]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "navfont2",
              class: [_vm.activeMenu === "/performs" ? "active" : ""]
            },
            [
              _c("a", [_vm._v("演出与购票")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "nav_ul" },
                _vm._l(_vm.programList, function(item, index) {
                  return _c(
                    "a",
                    {
                      key: index,
                      on: {
                        click: function($event) {
                          return _vm.goTo("/performs", item.name, item.id)
                        }
                      }
                    },
                    [_vm._v(_vm._s(item.name))]
                  )
                }),
                0
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "navfont2",
              class: [_vm.activeMenu === "/program" ? "active" : ""],
              on: {
                click: function($event) {
                  return _vm.goTo("/program")
                }
              }
            },
            [_c("a", [_vm._v("往期节目单")])]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "navfont2",
              class: [_vm.activeMenu === "/facilities" ? "active" : ""],
              on: {
                click: function($event) {
                  return _vm.goTo("/facilities")
                }
              }
            },
            [_c("a", [_vm._v("场地设施与租赁")])]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "navfont2",
              class:
                _vm.activeMenu === "/member/login" ||
                _vm.activeMenu === "/member/activityList" ||
                _vm.activeMenu === "/member/ruler"
                  ? "active"
                  : ""
            },
            [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.goTo("/member/login", 1)
                    }
                  }
                },
                [_vm._v("会员专区")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "nav_ul" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.goTo("/member/login", 1)
                      }
                    }
                  },
                  [_vm._v("会员中心")]
                ),
                _vm._v(" "),
                _c("a", [
                  _vm._v("\n            会员活动\n            "),
                  _c(
                    "div",
                    { staticClass: "nav_ul copy_li" },
                    _vm._l(_vm.memberList, function(item, index) {
                      return _c(
                        "a",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.goTo(
                                "/member/activityList",
                                index,
                                item.id
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.goTo("/member/ruler", 2)
                      }
                    }
                  },
                  [_vm._v("会员制度与权益")]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "navfont2",
              class: [_vm.activeMenu === "/connection" ? "active" : ""],
              on: {
                click: function($event) {
                  return _vm.goTo("/connection")
                }
              }
            },
            [_c("a", [_vm._v("联系我们")])]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61dd7a3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dd7a3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 